/** Date fields of any truck read model (transport detail, ZD draft truck); missing = not set. */
interface TruckDateFields {
  loadingDate?: string | null;
  departureDate?: string | null;
  estimatedDelivery?: string | null;
  estimatedArrival?: string | null;
  actualDelivery?: string | null;
}

const known = (value: string | null | undefined): string | null => (value ? value : null);

/**
 * The truck's loading day: what the transport form saves (`loadingDate`),
 * else the legacy `departureDate` of an older truck. `null` = nobody set it.
 * Same rate→legacy fallback idea as utils/truckFreightAmount.
 */
export function truckLoadingDate(truck: TruckDateFields): string | null {
  return known(truck.loadingDate) ?? known(truck.departureDate);
}

/**
 * When the truck reaches its unloading point: the actual delivery once known,
 * else the planned `estimatedDelivery` (transport form), else the legacy
 * `estimatedArrival`. `null` = nobody set it.
 */
export function truckDeliveryDate(truck: TruckDateFields): string | null {
  return known(truck.actualDelivery) ?? known(truck.estimatedDelivery) ?? known(truck.estimatedArrival);
}
